import { render } from "./app_ optimizationtest.vue?vue&type=template&id=5696b0e1&ts=true"
import script from "./app_ optimizationtest.vue?vue&type=script&lang=ts"
export * from "./app_ optimizationtest.vue?vue&type=script&lang=ts"

import "./app_ optimizationtest.vue?vue&type=style&index=0&id=5696b0e1&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__